export default __webpack_public_path__ + "static/media/leave.c965b8a8.svg";